import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { useCallback } from 'react'
import { globalQueryKeys } from '@opallabs/api'
import { stories, OpalApiResponseDocument } from '@opallabs/api/v3'
import {
  effectivePrivacyMap,
  type ReadableAccessMetadata,
} from '@opallabs/concepts'

type UseReadStoryAccessParams = UseQueryOptions<
  OpalApiResponseDocument<'GetStoryV3', 200>
> & {
  storyUuid: string
}

type Selector = (
  responseDocument: OpalApiResponseDocument<'GetStoryV3', 200>
) => ReadableAccessMetadata | undefined

export const useReadStoryAccess = (params: UseReadStoryAccessParams) =>
  useQuery({
    queryKey: globalQueryKeys.storyAccess(params.storyUuid),
    queryFn: () =>
      stories.readSingle({
        path: {
          story_id: params.storyUuid,
        },
        query: {
          expose: {
            meta: {
              access: 'true',
            },
          },
        },
      }),
    enabled: params.enabled,
    refetchOnMount: params.refetchOnMount,
    select: useCallback<Selector>((responseDocument) => {
      if (!responseDocument.meta?.access) return undefined
      const effectivePrivacyValue =
        responseDocument.data.meta?.effective_privacy

      return {
        ...responseDocument.meta.access,
        effectivePrivacy:
          effectivePrivacyValue != null
            ? effectivePrivacyMap[effectivePrivacyValue]
            : null,
      }
    }, []),
  })
